// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3l9T-","col":"styles_col__3J9iI"};